import type { FieldRegistryItem } from '../field-types'
import MultiSelectEntitySidebar from './multiselect/MultiSelectEntitySidebar.vue'
import MultiSelectField from './multiselect/MultiSelectField.vue'

export const multiSelectField: FieldRegistryItem<'multi_select'> = {
  field: MultiSelectField,
  entitySidebar: MultiSelectEntitySidebar,
}
